import { SetNonNullable } from 'type-fest'

import { DATE_FORMATTER } from '../../constants'
import { documentUrl } from '../../functions'
import { RelatedDocuments_DocumentFragment } from './__generated__/related-documents.graphql'

type RelatedJuris = SetNonNullable<
  NonNullable<NonNullable<RelatedDocuments_DocumentFragment['relatedJuris']>[number]>
>

type RelatedMotion = SetNonNullable<
  NonNullable<NonNullable<RelatedDocuments_DocumentFragment['relatedMotions']>[number]>
>
export type RelatedDoc = {
  docId: number
  isCurrentDoc: boolean
  label: string
  url: string
  publisher: string
  date: number
  formattedDate: string
  artifact: string
}

export const getRelatedDocs = (document: NonNullable<RelatedDocuments_DocumentFragment>) => {
  const { docId, parentDocument, relatedJuris, relatedMotions } = document
  const currentDocId = parentDocument?.docId || docId
  const juris: RelatedDoc[] = (relatedJuris || [])
    .filter((doc): doc is RelatedJuris => !!(doc?.docId && doc?.url && doc?.date))
    .map((item) => ({
      docId: item.docId,
      isCurrentDoc: item.docId === currentDocId,
      label: item.jurisTypeLabel,
      url: documentUrl(item.url),
      publisher: item.publisher?.acronym || '',
      date: item.date,
      formattedDate: DATE_FORMATTER.format(new Date(item.date)),
      artifact: item.artifact,
    }))

  const motions: RelatedDoc[] = (relatedMotions || [])
    .filter((doc): doc is RelatedMotion => !!(doc?.docId && doc?.url && doc?.courtPublishingDate))
    .map((item) => ({
      docId: item.docId,
      isCurrentDoc: item.docId === currentDocId,
      label: item.motionTypeLabel,
      url: documentUrl(item.url),
      publisher: item.publisher?.acronym || '',
      date: item.courtPublishingDate,
      formattedDate: DATE_FORMATTER.format(new Date(item.courtPublishingDate)),
      artifact: item.artifact,
    }))

  const merged = [...juris, ...motions]
  const initial = [merged.find((item) => item.docId === currentDocId)].filter(
    (item): item is RelatedDoc => !!item
  )
  return merged
    .reduce((acc, value) => {
      if (
        acc.find(
          (item): item is RelatedDoc =>
            item.formattedDate === value.formattedDate && item.label === value.label
        )
      ) {
        return acc
      }
      return [...acc, value]
    }, initial)
    .sort((a, b) => {
      return b.date - a.date
    })
}
